// extracted by mini-css-extract-plugin
export default {"root":"_1MmHj","small":"_1HUzd","normal":"UlfHj"};